import React from "react"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { MobergColumn, MobergFontFamily, MobergFontSize } from "../../../../../../../../../Moberg"
import { IICPatternType } from "../../../../../Types/EventReview"
import { useEventReviewForm } from "../../../../../../../../../Providers/EventReviewProvider"

interface IICPatternTypeFormProps {
  style?: React.CSSProperties
}

export const IICPatternTypeForm: React.FC<IICPatternTypeFormProps> = () => {
  const eventReviewForm = useEventReviewForm()

  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    eventReviewForm.setPatternType(event.target.value as IICPatternType)
  }

  return (
    <MobergColumn gap="4px">
      <FormControl>
        <FormLabel
          sx={{
            color: "var(--color-text-primary)",
            fontFamily: MobergFontFamily.REGULAR,
            fontSize: MobergFontSize.REGULAR,
            fontWeight: 500,
            marginBottom: "8px",
            "&.Mui-focused": { color: "var(--color-text-primary)" },
          }}
        >
          Select predominant pattern of NON-SEIZURE epochs
        </FormLabel>
        <RadioGroup
          name="event-review-iic-pattern-type-form"
          value={eventReviewForm.patternType}
          onChange={handleSelect}
          sx={{ gap: "4px" }}
        >
          {Object.values(IICPatternType).map((type) => (
            <FormControlLabel
              key={type}
              value={type}
              control={(
                <Radio
                  size="small"
                  sx={{
                    padding: "3px 6px 3px 0",
                    color: "var(--text-secondary-color)",
                    "&.Mui-checked": { color: "var(--color-accent-interactive)" },
                  }}
                />
              )}
              label={type}
              sx={{
                alignItems: "flex-start",
                marginLeft: 0,
                marginRight: 0,
                color: "var(--color-text-primary)",
                "& .MuiFormControlLabel-label": {
                  fontFamily: MobergFontFamily.REGULAR,
                  fontSize: MobergFontSize.SMALL,
                  lineHeight: 1.25,
                  paddingTop: "4px",
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </MobergColumn>
  )
}
